import produce from 'immer'
import { Action, Actions } from 'src/state/actions/actions'
import { typesCategoriesTranslateState } from './TypesCategoriesTranslateReducer';

export const loadDetailsHandler = (state: typesCategoriesTranslateState) => {

    return produce(state,(draft) => {
        draft.details=null;
        draft.isLoadingPage = true;
    });
};
export const setDetailsHandler = (
    state: typesCategoriesTranslateState,
    action: Action<typeof Actions.common.categoriesTranslate.loadDetails>,
  ) => {
    return produce(state, (draft) => {
      draft.details = action.payload;
      draft.isLoadingPage = false;
    });
  };
  
  export const clearDetailsHandler = (state: typesCategoriesTranslateState) => {
    return produce(state, (draft) => {
      draft.details = null;
    });
  };